import { FileUpload, Flex, Icon, Text } from "@chakra-ui/react";
import { LuFileX, LuX } from "react-icons/lu";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs";

interface FileItemProps {
  file: File;
  errorMessage?: string;
  isRejected?: boolean;
}

export const FileItem = ({
  file,
  errorMessage,
  isRejected = false,
}: FileItemProps) => {
  return (
    <FileUpload.Item
      w="full"
      file={file}
      border="none"
      rounded="none"
      _hover={{
        bg: "neutral.100",
      }}
      p={0}
      bg={isRejected ? "red.50" : undefined}
    >
      <Flex
        justify="space-between"
        p={3}
        align="center"
        w="full"
        borderBottom="1px solid"
        borderColor="neutral.200"
        gap={2}
      >
        <Flex align="center" gap={2} overflow="hidden">
          <Icon
            as={isRejected ? LuFileX : BsFillFileEarmarkPdfFill}
            boxSize={5}
            color={isRejected ? "red.500" : "neutral.600"}
          />
          <Text textStyle="sm" fontWeight="normal" lineClamp={1}>
            {file.name}
          </Text>
          {errorMessage && (
            <Text textStyle="xs" fontWeight="normal" color="red.500">
              {errorMessage}
            </Text>
          )}
        </Flex>
        {!errorMessage ? (
          <Flex rounded="full">
            <FileUpload.ItemDeleteTrigger
              boxSize="5"
              layerStyle="outline.subtle"
              color="neutral.400"
              shadow="none"
            >
              <LuX />
            </FileUpload.ItemDeleteTrigger>
          </Flex>
        ) : null}
      </Flex>
    </FileUpload.Item>
  );
};
